import React, { useEffect, useState } from 'react';
import Sheet from 'react-modal-sheet';
import useDialogA11y from '../hooks/useDialogA11y';
import useLoadingAnnouncement from '../hooks/useLoadingAnnouncement';

const PRIVACY_POLICY_URL = 'https://finvu.in/privacy';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
	const dialogRef = useDialogA11y(isOpen, onClose);
	const [status, setStatus] = useState('loading');

	useEffect(() => {
		if (isOpen) setStatus('loading');
	}, [isOpen]);

	useLoadingAnnouncement(
		status === 'loading',
		'Loading privacy policy',
		status === 'loaded' ? 'Privacy policy loaded' : ''
	);

	return (
		<Sheet isOpen={isOpen} onClose={onClose}>
			<Sheet.Container>
				<div
					ref={dialogRef}
					role="dialog"
					aria-modal="true"
					aria-labelledby="privacy-modal-title"
				>
					<div className="d-flex align-items-center justify-content-between px-3 pt-3 pb-2">
						<h2 id="privacy-modal-title" className="fs-16 fw-700 m-0">
							Privacy Policy
						</h2>
						<button
							type="button"
							className="closeModal"
							onClick={onClose}
							aria-label="Close Privacy Policy"
							style={{
								background: 'none',
								border: 'none',
								fontSize: '24px',
								fontWeight: 'bold',
								cursor: 'pointer',
								padding: '4px 10px',
								lineHeight: 1,
								minWidth: '24px',
								minHeight: '24px',
							}}
						>
							×
						</button>
					</div>
					{status !== 'error' && (
						<p className="px-3 mb-2 fs-14">
							Having trouble viewing this below?{' '}
							<a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
								Open Privacy Policy in a new tab
							</a>
						</p>
					)}
					<Sheet.Content>
						<div style={{ height: '70vh', width: '100%' }}>
							{status === 'error' ? (
								<div className="px-3 py-4 text-center" role="alert">
									<p>We couldn&apos;t load the privacy policy here.</p>
									<a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
										Open Privacy Policy in a new tab
									</a>
								</div>
							) : (
								<iframe
									src={PRIVACY_POLICY_URL}
									style={{
										width: '100%',
										height: '100%',
										border: 'none',
										borderRadius: '8px',
									}}
									title="Finvu Privacy Policy"
									loading="lazy"
									sandbox="allow-same-origin allow-scripts"
									onLoad={() => setStatus('loaded')}
									onError={() => setStatus('error')}
								/>
							)}
						</div>
					</Sheet.Content>
				</div>
			</Sheet.Container>
			<Sheet.Backdrop />
		</Sheet>
	);
};

export default PrivacyPolicyModal;
